import { AbstractDialog } from "./abstract_dialog.js";
import { DialogManager } from "./dialog_manager.js";
import { RoundedRectangle } from "../common_ui_elements/rounded_rectangle.js";
import { RoundedRectButton } from "../common_ui_elements/buttons/rounded_rect_button.js";
import { UITextElement } from "../common_ui_elements/ui_text_element.js";
import { TextStyleScheme } from "../common_ui_elements/text_style_scheme.js";
import { MyTextAlign, MyTextVerticalAlign } from "../common_ui_elements/ui_text_element.js";

export class FeedbackNotifDialog extends AbstractDialog
{
  private message_text!: UITextElement;

  constructor( message_key: string )
  {
    const body_w = LayoutScaler.widthFromDesign( 800 );
    const body_h = LayoutScaler.heightFromDesign( 300 );
    const body_x = ( DialogManager.getWidth() - body_w ) / 2;
    const body_y = ( DialogManager.getHeight() - body_h ) / 2;

    super( DialogManager.ctx, body_x, body_y, body_w, body_h );

    this.createBackground();
    this.createText( message_key );
    this.createOkButton();
  }

  private createBackground(): void
  {
    const bg = new RoundedRectangle(
      this.ctx, 0, 0, this.rect.getW(), this.rect.getH(),
      LayoutScaler.cornerRadiusFromDesign( 20 ),
      "#FFFFFF"
    );
    this.addChild( bg );
  }

  private createText( message_key: string ): void
  {
    const text_w = LayoutScaler.widthFromDesign( 700 );
    const text_h = LayoutScaler.heightFromDesign( 140 );
    const text_x = ( this.rect.getW() - text_w ) / 2;
    const text_y = LayoutScaler.yFromDesign( 40 );

    const text = this.message_text = new UITextElement(
      this.ctx, text_x, text_y, text_w, text_h,
      {
        localization_key: message_key,
        font_size: LayoutScaler.textSizeFromDesign( 40 ),
        text_style: TextStyleScheme.geologica,
        text_color: "#373737",
        text_align: MyTextAlign.Center,
        vertical_align: MyTextVerticalAlign.Center,
        font_weight: 600,
        auto_wrap: true,
      }
    );
    this.addChild( text );
  }

  private createOkButton(): void
  {
    const btn_w = LayoutScaler.widthFromDesign( 400 );
    const btn_h = LayoutScaler.heightFromDesign( 85 );
    const btn_x = ( this.rect.getW() - btn_w ) / 2;
    const btn_y = LayoutScaler.yFromDesign( 195 );

    const btn = new RoundedRectButton(
      this.ctx, btn_x, btn_y, btn_w, btn_h,
      "#DE934F", "OK", "#fff"
    );
    btn.setOnClick( () => this.close() );
    this.addChild( btn );
  }

  render(): void
  {
    this.startRender();
    this.finishRender();
  }

  public static open( message_key: string ): FeedbackNotifDialog
  {
    return DialogManager.openPooled( "FeedbackNotifDialog", message_key, () => new FeedbackNotifDialog( message_key ) ) as FeedbackNotifDialog;
  }

  public override isPoolable(): boolean { return true; }

  public override onReuse( message_key: string ): void
  {
    this.message_text.setLocalizationKey( message_key );
  }

  name(): string { return 'FeedbackNotifDialog'; }
}
